import { render, staticRenderFns } from "./CollapsibleCard.vue?vue&type=template&id=0c041013"
import script from "./CollapsibleCard.vue?vue&type=script&lang=js"
export * from "./CollapsibleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports